"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _prefixUrl = require("@mapbox/batfish/modules/prefix-url");

var _routeTo = require("@mapbox/batfish/modules/route-to");

var _example = _interopRequireDefault(require("../../components/example"));

var _protected_area_service = _interopRequireDefault(require("./protected_area_service.html"));

var _pageShell = _interopRequireDefault(require("/home/toannc/ekmap-platform-map-javascript/docs/components/page-shell.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var frontMatter = {
  title: 'Thông tin khu vực bảo tồn',
  description: 'Dịch vụ cung cấp thông tin về khu vực bảo tồn.',
  topics: ['Service'],
  thumbnail: 'protected-area',
  order: 5,
  contentType: 'example',
  layout: 'page',
  hideFeedback: false,
  language: ['JavaScript'],
  products: ['Mapbox GL JS'],
  headings: []
};

var MarkdownReact = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MarkdownReact, _React$PureComponent);

  var _super = _createSuper(MarkdownReact);

  function MarkdownReact() {
    _classCallCheck(this, MarkdownReact);

    return _super.apply(this, arguments);
  }

  _createClass(MarkdownReact, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_react["default"].createElement(_pageShell["default"], _extends({}, props, {
        frontMatter: frontMatter
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "V\xED d\u1EE5 n\xE0y cung c\u1EA5p th\xF4ng tin khu v\u1EF1c b\u1EA3o t\u1ED3n t\u1EA1i m\u1ED9t t\u1ECDa \u0111\u1ED9 \u0111\u1ECBa l\xFD. D\u1EEF li\u1EC7u cung c\u1EA5p tr\xEAn l\xE3nh th\u1ED5 Vi\u1EC7t Nam (click tr\xEAn b\u1EA3n \u0111\u1ED3 \u0111\u1EC3 xem)"), /*#__PURE__*/_react["default"].createElement(_example["default"], _extends({
        html: _protected_area_service["default"]
      }, this.props))));
    }
  }]);

  return MarkdownReact;
}(_react["default"].PureComponent);

exports["default"] = MarkdownReact;